// Add entry-embed class to post entry after being successfully loaded
(function($) {
    'use strict';

    var tries = 0;
    var $body = $('.entry__body');

    if (!$body.length) {
        return;
    }

    var intervalId = setInterval(function(){
        var embeds = $body.find("> p > div:has(iframe), > div:not(.modal, :has(.ad_spot)):has(iframe)").not('.entry-embed');
        embeds.addClass('entry-embed');

        if (tries === 50) {
            clearInterval(intervalId);
        }
        tries++;
    }, 500);
})(jQuery);